import { render, staticRenderFns } from "./JoinCompetition.vue?vue&type=template&id=465297c2&scoped=true&"
import script from "./JoinCompetition.vue?vue&type=script&lang=js&"
export * from "./JoinCompetition.vue?vue&type=script&lang=js&"
import style0 from "./JoinCompetition.vue?vue&type=style&index=0&id=465297c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465297c2",
  null
  
)

export default component.exports